import { useTranslation } from "@/core/i18n";
import { BlockingModal } from "organisms/blocking-modal/BlockingModal";

interface AccessTemporarilySuspendedModalProps {
  open: boolean;
  platformName: string;
  contactPhone?: string | null;
  contactEmail?: string | null;
  showSwitchLocations: boolean;
  onSwitchLocations: () => void;
}

export const AccessTemporarilySuspendedModal = (props: AccessTemporarilySuspendedModalProps) => {
  const { t } = useTranslation();
  return (
    <BlockingModal
      {...props}
      title={t("accessTemporarilySuspendedModal.title")}
      description={<p>{t("accessTemporarilySuspendedModal.description")}</p>}
    />
  );
};
